import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({
  color = defaultIconColor,
  size = defaultSize,
  outlined = false,
  ...props
}: SVGComponentPropsType) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2">
      <path
        clipRule="evenodd"
        d="M17.6 19c-.9.2-1.7.7-2.3 1.4a4.5 4.5 0 0 1-6.6 0A4.4 4.4 0 0 0 6.4 19c-2.6-.5-4-3.2-3.3-5.6.3-1 .3-1.9 0-2.8-.8-2.4.7-5 3.3-5.6.9-.2 1.7-.7 2.3-1.4a4.5 4.5 0 0 1 6.6 0c.6.7 1.4 1.2 2.3 1.4 2.6.5 4 3.2 3.3 5.6-.3 1-.3 1.9 0 2.8.8 2.4-.7 5-3.3 5.6Z"
      />
      <path d="m8 11 3 3 5-5" />
    </g>
  </svg>
);
